import * as s from "./ItemRecorderStyled";
import { COLORS } from "styles/colors";
import { MarkerDataSystem } from "api/interfaces/dashboardInterface.interface";
import RecorderInfoView from "../RecorderInfoView";
import Popover from "antd/lib/popover";
import WebAppLink from "components/blocks/link/WebAppLink";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { ChildrenRecorder } from "./ChildrenRecorder";
import { getMarker, getTopAlertStatusString } from "../../../utils";
import DefaultThumbnail from "components/atoms/image/DefaultThumbnail";
import VideoThumbnail from "components/atoms/image/thumbnail/VideoThumbnail";
import * as mediaQuery from "components/MediaQuery";

type ItemMultiRecorderType = {
  system: MarkerDataSystem;
  onSelectRecorder: (system: MarkerDataSystem) => void;
  cloudStatus: boolean;
};

export const ItemMultiRecorder = ({
  system,
  onSelectRecorder,
  cloudStatus,
}: ItemMultiRecorderType) => {
  const theme = useAppSelector((state) => state.theme.theme);
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const tmpStatus = getTopAlertStatusString(system);
  const isMobile = mediaQuery.useIsMobile();

  return (
    <s.Item key={`recorder-list-map-view-${system.recorderId}`}>
      <div className="left-info">
        <div className="system-alert-marker">
          <img src={getMarker(tmpStatus)} alt={`marker-${tmpStatus}`} />
        </div>

        <div className="system-info">
          <div className="system-title">
            <h5>{system.mergedSystemName}</h5>
            <div className="web-app-link-wrapper">
              <WebAppLink
                {...system}
                accountId={selectedAccount.accountId}
                cloudStatus={cloudStatus}
              />
            </div>
          </div>
          {system.thumbnail && (
            <div className="system-thumbnail">
              <VideoThumbnail
                videoLoss={false}
                thumbnailUrl={system.thumbnail}
              />
            </div>
          )}

          {system.recorders && (
            <ul className="spectrum-system-ul">
              {system.recorders.map((rec: MarkerDataSystem, index: number) => {
                if(isMobile) {
                  return (
                    <div key={`chilren-recorder-${index}`}>
                      <ChildrenRecorder rec={rec} onSelectRecorder={onSelectRecorder} />
                    </div>
                  );
                }
                return (
                  <Popover
                    key={`chilren-recorder-popover-${index}`}
                    trigger="hover"
                    placement="right"
                    content={
                      <RecorderInfoView
                        system={rec}
                        cloudStatus={cloudStatus}
                      />
                    }
                    zIndex={989}
                    style={{
                      padding: 0,
                    }}
                    color={theme === "light" ? COLORS.WHITE : "#0d1119"}
                  >
                    <div>
                      <ChildrenRecorder
                        rec={rec}
                        onSelectRecorder={onSelectRecorder}
                      />
                    </div>
                  </Popover>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </s.Item>
  );
};
